import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSalesForce } from 'services/api/requests/requests';

import { mapErrorToToastProps } from '../../../utils/forms/mapErrorToToastProps';

export const useCreateSalesForce = (form?, setForm?, formProps?) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(createSalesForce, {
		onSuccess: success => {
			queryClient.invalidateQueries(['commercialHierarchy-list']);
			toast({
				title: 'Criado com sucesso!',
				description: 'Força de Venda criada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
			if (form && setForm) {
				setForm({
					...form,
					forcaVenda: success.id,
				});
			}
			if (formProps) {
				const { setValue } = formProps;
				setValue('forca_venda', success?.id);
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar Força de Venda!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
